import { type AppLocale } from './locales';

export function applyLocaleDocument(locale: AppLocale): void {
  if (typeof document === 'undefined') {
    return;
  }
  document.documentElement.lang = locale;
}
